import React, { Component } from "react";
import BackgroundImage from "../../images/bg-image-2.jpg"

class LocationSectionComponent extends Component {
    render() { 
        return (  <section className="section-xl bg-gray-dark bg-gray-dark-overlay text-center text-md-left" style={{backgroundImage: 'url('+BackgroundImage+')', color: 'white'}} id="lokacija">
        <div className="shell-fluid shell-condensed">
          <div className="range range-md-reverse range-xs-middle range-md-right range-50">
            <div className="cell-md-2 cell-lg-1"></div>
            <div className="cell-md-5 cell-lg-4">
              <div className="inset-1">
                <div className="box-contacts-col">
                  <div className="box-contacts-block large">
    
                    <address>
                      <a><h4 style={{lineHeight: "35px"}}><i className="icon icon-xs link-gray-base fa-map-marker"></i>&nbsp;Lasla Gala 3, Novi Sad</h4></a><br/>
                      <a href="tel:+381628796883"><h4 style={{lineHeight: "35px"}}><i className="icon icon-xs link-gray-base fa-phone"></i> +381 62 879 6883</h4></a><br/>
                      <a href="https://www.instagram.com/ateljestojcic/?hl=en"><h4 style={{lineHeight: "35px"}}><i className="icon icon-xs link-gray-base fa-instagram"></i>&nbsp;ateljestojcic</h4></a> 
                    </address>
                  </div>
                  <div className="divider divider-nebula"></div>
                  <div className="box-contacts-block">
                    <h3><a className="icon icon-xs link-gray-base fa-clock-o" href="#"></a> Radno vreme</h3>
                    <dl className="box-contacts-terms-list large">
                      <dt>Ponedeljak – Petak</dt>
                      <dd style={{fontSize: '12px', color: "white"}}>10.00 - 20.00h</dd>
                      <dt>Subota</dt>
                      <dd style={{fontSize: '12px', color: "white"}}>10.00 - 17.00h</dd>
                      <dt>Nedelja</dt>
                      <dd style={{fontSize: '12px', color: "white"}}>Neradna</dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <div className="cell-md-5 cell-lg-6">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2809.054663382377!2d19.83622341555015!3d45.24668737909891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b11d7ec1068f7%3A0x1d4019214748b9e3!2zQXRlbGplIFN0b2rEjWnEhw!5e0!3m2!1sen!2srs!4v1666022863508!5m2!1sen!2srs" width="600" height="450" style={{border:0, width:'100%'}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className="cell-md-2 cell-lg-1"></div>
          </div>
        </div>
      </section>);
    }
}
 
export default LocationSectionComponent;